import type { UUID } from "utils";

export const URL_PARAMS = {
  PREVIEW_ACCOUNT: "preview",
  PREVIEW_TRANSACTION: "transaction",
  CONFIGURE: "configure",
};

export const CONFIGURE_PARAM_VALUES = {
  NAMED_ACCOUNTS_NOTIFICATIONS: "named-accounts-notifications",
  PAYMENTS_NOTIFICATIONS: "payments-notifications",
  LIFECYCLE_NOTIFICATIONS: "lifecycle-notifications",
  ORDERING_NOTIFICATIONS: "ordering-notifications",
} as const;

const BASE_URL = "/accounts";
const OVERVIEW_BASE_URL = "/connect/overview";

export const PAGE_URLS = {
  home: "/",
  list: OVERVIEW_BASE_URL,
  accounts: `${BASE_URL}`,
  voltAccounts: `${BASE_URL}/volt-accounts`,
  namedAccounts: `${BASE_URL}/named-accounts`,
  connect: `${BASE_URL}/connect`,
  configuration: `${BASE_URL}/configuration`,
  beneficiaries: `${BASE_URL}/beneficiaries`,
  createTrustedBeneficiary: `${BASE_URL}/beneficiaries/create`,
  merchantBeneficiaries: `${BASE_URL}/beneficiaries/merchant`,
  namedAccountsBeneficiaries: `${BASE_URL}/beneficiaries/named-accounts`,
  namedAccountsConfigurationEdit: `${BASE_URL}/configuration?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.NAMED_ACCOUNTS_NOTIFICATIONS}`,
  paymentsConfigurationEdit: `${BASE_URL}/configuration?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.PAYMENTS_NOTIFICATIONS}`,
  lifecycleConfigurationEdit: `${BASE_URL}/configuration?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.LIFECYCLE_NOTIFICATIONS}`,
  orderingConfigurationEdit: `${BASE_URL}/configuration?${URL_PARAMS.CONFIGURE}=${CONFIGURE_PARAM_VALUES.ORDERING_NOTIFICATIONS}`,
  details: `${OVERVIEW_BASE_URL}/:id`,
  vibans: `${OVERVIEW_BASE_URL}/:id/vibans`,
  virtualAccounts: `${OVERVIEW_BASE_URL}/:id/virtual-accounts`,
  getLinkToAccountDetails: (id: UUID) => `${OVERVIEW_BASE_URL}/${id}`,
  getLinkToAccountDetailsVibans: (id: UUID) =>
    `${OVERVIEW_BASE_URL}/${id}/vibans`,
  getLinkToAccountDetailsVirtualAccounts: (id: UUID) =>
    `${OVERVIEW_BASE_URL}/${id}/virtual-accounts`,
  getLinkToAccountPreview: (id: UUID, params?: string) => {
    if (params) {
      return `${OVERVIEW_BASE_URL}?${params}&${URL_PARAMS.PREVIEW_ACCOUNT}=${id}`;
    }

    return `${OVERVIEW_BASE_URL}?${URL_PARAMS.PREVIEW_ACCOUNT}=${id}`;
  },
};
